// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__ycbtL","white":"tooltip_white__SzHW9","black":"tooltip_black__cSE4a"};